import { sendSumoLog } from './sumoLogger';
import { fetchStandbyInspectorsList } from './fetchStandbyInspectorsList';
import { updateCurStandbyInspector, updateError } from '../../stores/notifications';
import { UPDATE_STANDBY_INSPECTOR } from '../queries/queries';
import GetApolloClient from '../../Apollo';

/**
 * Update a Standby Inspector.
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @param fullUserBody - the data for the Standby Inspector record to update.
 * @param immediate - whether to immediately return the results (rather than using dispatch)
 * @returns {Promise<[StandbyInspectors]>} - The updated list of Standby Inspectors.
 */
export const putStandbyInspector = async (
  token,
  dispatch,
  fullUserBody,
  immediate = false
) => {
  const client = GetApolloClient(token);

  try {
    const {
      data: { updateStandbyInspector: curStandbyInspector },
    } = await client.mutate({
      mutation: UPDATE_STANDBY_INSPECTOR,
      variables: {
        id: fullUserBody.id,
        user_id: fullUserBody.user_id,
        input: { ...fullUserBody.user },
      },
    });

    if (immediate) {
      updateCurStandbyInspector(curStandbyInspector, dispatch);
      return curStandbyInspector;
    }

    fetchStandbyInspectorsList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'putStandbyInspector';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
